import { useLang } from '@/i18n';
import EFXGanPower from 'elem/ui-assets/icons/unregular/EFXGanPower';
import EfImg from 'elem/ui/ef-img';
import EfInfoSection from 'elem/ui/ef-info-section';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionE');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca', 'mx', 'br'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const { pageStatus } = useProductStore();
    const [enter, setEnter] = useState(false);

    const items = [
        {
            hour: t('a_text2'),
            text: t('a_text1'),
        },
        {
            hour: t('b_text2'),
            text: t('b_text1'),
        },
        {
            hour: t('c_text2'),
            text: t('c_text1'),
        },
        ...(locale === 'kr'
            ? [
                  {
                      hour: t('d_text2'),
                      text: t('d_text1'),
                  },
              ]
            : []),
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: `.R3Page .${styles.TheComp} .info`,
                triggerHook: 1,
                offset: '30%',
                duration: '100%',
                onEnter: () => setEnter(true),
                // onLeave: () => setEnter(false),
            });
        }
    }, []);

    const NAImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724577360662/runtime.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724577360459/runtime%20(1).jpg',
    };
    const EUImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724999975133/eu1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724999975167/eu2.jpg',
    };
    const UKImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724999975563/uk1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724999975606/uk2.jpg',
    };
    const PHImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751090638839/H.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751090638612/H-m.jpg',
    };

    const imgLocale: any = {
        us: NAImg,
        ca: NAImg,
        br: NAImg,
        mx: NAImg,
        uk: UKImg,
        eu: EUImg,
        de: EUImg,
        fr: EUImg,
        it: EUImg,
        es: EUImg,
        ph: PHImg,
    };
    const imgA = imgLocale[locale] || imgLocale['eu'];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <div className="logo">
                <EFXGanPower />
            </div>
            <EfInfoSection
                title={t('title')}
                desc={t.rich('desc', {
                    sup: (tx: string) => <sup>{tx}</sup>,
                })}
            />
            <div className="box">
                <div className="img">
                    <EfImg pc={imgA.pc} pad={imgA.pc} h5={imgA.h5} />
                </div>
                <div className="info">
                    <div className="info-inner">
                        <p className="inner-title">{t('con1')}</p>
                        <ul className="items">
                            {items?.map((item: any, k: number) => (
                                <li className={`item item-${k + 1}${enter ? ' enter' : ''}`} key={k}>
                                    <p className="bar"></p>
                                    <span className="hour">{item.hour}</span>
                                    <p className="text">{item.text}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
